import { Button, Icon } from "@legal-500/legal500-design-system";
import styles from "./FormSuccessScreen.module.css";

type FormSuccessScreenProps = {
  mode: "create" | "edit" | "delete" | "cancel";
  itemName?: string;
  singularName: string;
  onClose: () => void;
  onCreateAnother?: () => void;
};

export function FormSuccessScreen({
  mode,
  itemName,
  singularName,
  onClose,
  onCreateAnother,
}: FormSuccessScreenProps) {
  const title =
    mode === "create"
      ? `${singularName} Created!`
      : mode === "edit"
        ? `${singularName} Updated!`
        : mode === "cancel"
          ? `${singularName} Cancelled!`
          : `${singularName} Deleted!`;

  const message =
    mode === "create"
      ? `${itemName || `Your ${singularName}`} has been created successfully.`
      : mode === "edit"
        ? `${itemName || `Your ${singularName}`} has been updated successfully.`
        : mode === "cancel"
          ? `${itemName || `The ${singularName}`} has been cancelled successfully.`
          : `${itemName || `The ${singularName}`} has been deleted successfully.`;

  const icon = "check";
  const iconClass =
    mode === "delete" || mode === "cancel" ? styles.iconCircleDelete : styles.iconCircle;

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <div className={iconClass}>
          <Icon icon={icon} size="xlarge" />
        </div>
      </div>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.message}>{message}</p>
      <div className={styles.actions}>
        {mode === "create" && onCreateAnother && (
          <Button onClick={onCreateAnother} variant="outlined" color="default">
            Create Another
          </Button>
        )}
        <Button onClick={onClose} variant="contained" color="primary">
          Done
        </Button>
      </div>
    </div>
  );
}
